import { enEnviroment } from 'types/enums';

import EduzzAppsToolbar from '@eduzz/apps-toolbar';

import { ENV } from '../settings';
import store from '../store';
import { selectUser } from '../store/selectors';

class EduzzToolbarService {
  private toolbar;

  constructor() {
    this.toolbar = EduzzAppsToolbar({
      application: 'sun',
      show: true,
      env: ENV as enEnviroment
    });
  }

  public async setUser() {
    const { id, email, name, belt, isSupport, isClubeBlack, supportUserId } = selectUser(store.getState());

    const eduzzToolbar = await this.toolbar;
    eduzzToolbar.setUser({
      id,
      email,
      name,
      belt,
      isSupport,
      supportId: supportUserId,
      isClubeBlack
    });

    eduzzToolbar.show();
  }

  public async clearUser() {
    const eduzzToolbar = await this.toolbar;
    eduzzToolbar.hide();
  }
}
export { EduzzToolbarService };
export default new EduzzToolbarService();
